import script from "./FavoritesHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritesHeader.vue?vue&type=script&setup=true&lang=js"

import "./FavoritesHeader.vue?vue&type=style&index=0&id=9b0dec08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b0dec08"]])

export default __exports__